import './components/studio-themes.css';
import { HeroCinemaPortal } from './components/HeroCinemaPortal';
import { PromptLabSection } from './components/PromptLabSection';
import { BlueprintTo3DSection } from './components/BlueprintTo3DSection';
import { MorphTypographySection } from './components/MorphTypographySection';
import { GalleryShowcaseSection } from './components/GalleryShowcaseSection';
import { ConversionEcosystemSection } from './components/ConversionEcosystemSection';

export function LandingPage() {
  return (
    <div className="landing-page relative flex flex-col bg-background selection:bg-brand selection:text-white">
      {/* HỒI I: Hero Cinematic & Clip-Path Portal 1 */}
      <HeroCinemaPortal />

      {/* HỒI II: Prompt Laboratory & Text Scrub Philosophical Highlight */}
      <PromptLabSection />

      {/* HỒI III: Canvas 60fps Blueprint & 3D Layer Explode Portal */}
      <BlueprintTo3DSection />

      {/* HỒI IV: Layout Morphing Flip, Variable Font & Bento Grid */}
      <MorphTypographySection />

      {/* HỒI V: Real Presentation Gallery Horizontal Showcase */}
      <GalleryShowcaseSection />

      {/* HỒI VI: Conversion Ecosystem (Audience, Pricing, FAQ & Final CTA) */}
      <ConversionEcosystemSection />
    </div>
  );
}

export default LandingPage;
